import { Icon } from "@mui/material";
import { useEffect, useState } from "react";
import "./select.css";

const Select = ({
  label = "Label",
  value,
  options = {},
  onSelect,
  className,
  noAdd
}) => {
  const [current, setCurrent] = useState("");
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [selection, setSelection] = useState({});
  useEffect(() => {
    let result = options?.selector(selection, options.dataset);
    if (result) {
      const [data, value, label, placeholder] = result;
      setData(data);
      setMeta({ value, label, placeholder });
    } else {
      setData(null);
    }
  }, [options, selection]);
  return (
    <div className="e1-select-container">
      <span className="e1-select-label">{label.toUpperCase()}:</span>
      {noAdd ? null : Object.keys(selection)?.length ? (
        <span className="e1-select-current" style={!data ? { flex: 1 } : {}}>
          {options.label(selection)}
        </span>
      ) : null}
      {data ? (
        <select
          value={value || current}
          onChange={e => {
            options.pick(
              selection,
              data.find(d => d[meta?.value] === e.target.value),
              setSelection,
              onSelect
            );
            if (!noAdd) {
              setCurrent("");
            }
          }}
          className={"e1-select" + " " + className}
        >
          {[
            {
              [meta?.value]: meta?.placeholder || "None",
              [meta?.label]: meta?.placeholder || "None"
            },
            ...data
          ].map(option => (
            <option key={option[meta?.value]} value={option[meta?.value]}>
              {option[meta?.label]}
            </option>
          ))}
        </select>
      ) : null}
      <Icon
        sx={{
          color: !Object.keys(selection)?.length
            ? "grey !important"
            : "#fff !important"
        }}
        onClick={() => {
          setCurrent("");
          setSelection({});
          if (noAdd) {
            onSelect(null);
          }
        }}
      >
        clear
      </Icon>
      {!noAdd ? (
        <button
          onClick={() => {
            if (data) return;
            onSelect(selection);
            setSelection({});
            setCurrent("");
          }}
          className={`e1-btn small ${!data ? "" : "disabled"}`}
        >
          <Icon sx={{ color: "#fff !important" }}>add</Icon>
        </button>
      ) : null}
    </div>
  );
};
export default Select;
